module.exports = __webpack_public_path__ + "website/img/func1-3.a5ac0193.jpg";